/**
 * en-GB messages added by Phase 1 task S1 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s1EnGB = {
    'nav.section.manage': 'Manage',
    'nav.sites': 'Sites',
    'nav.sites.desc': 'Site set-up, kiosk look, privacy and devices',
    'nav.groups': 'Groups',
    'nav.groups.desc': 'Visitor and staff groups, sign-in options and members',
    'error.site_limit': 'Your plan allows {max} active sites. Archive one or ask for a larger plan.',
    'error.site_has_devices': 'This site still has active devices. Unpair them first.',
    'error.site_name_taken': 'Another active site already has that name.',
    'error.group_not_empty': 'This group has members or visits, so it cannot be deleted. Archive it instead.',
    'error.group_kind_locked': 'A group cannot change between standard and repeat after it is created.',
    'error.group_name_taken': 'Another active group already has that name.',
    'settings.sites': 'Sites',
    'settings.sites.maxSites': 'Most active sites allowed (0 = no limit)',
    'settings.sites.kioskBranding': 'Kiosk look',
    'settings.sites.kioskBranding.welcomeImageFileId': 'Welcome image',
    'settings.sites.kioskBranding.logoFileId': 'Logo',
    'settings.sites.kioskBranding.backgroundColour': 'Background colour',
    'settings.sites.kioskBranding.textColour': 'Text colour',
    'settings.sites.kioskBranding.welcomeText': 'Welcome text',
    'settings.sites.kioskBranding.showClock': 'Show the clock',
    'settings.sites.privacy': 'Privacy',
    'settings.sites.privacy.autocompleteReturningVisitors': 'Suggest returning visitors as they type',
    'settings.sites.privacy.exactMatchPreRegisteredOnly': 'Show pre-registered names only on an exact match',
    'settings.sites.privacy.hideVisitorsOnSignOutList': 'Hide visitors on the sign-out list',
    'settings.sites.privacy.requireFullName': 'Require a full name',
    'settings.sites.privacy.hideProductLogoOnThankYou': 'Hide the CloudSign logo on the thank-you screen',
    'settings.sites.features': 'Features',
    'settings.sites.features.qrScanning': 'Scan QR codes at the kiosk',
    'settings.sites.features.visitorPhotos': 'Allow visitor photos',
    'settings.groups': 'Groups',
    'settings.groups.kiosk': 'Kiosk',
    'settings.groups.kiosk.showOnKiosk': 'Show this group on the kiosk',
    'settings.groups.kiosk.allowNewMembersFromKiosk': 'Let new members add themselves at the kiosk',
    'settings.groups.kiosk.allowMembersUpdatePhoto': 'Let members retake their photo at the kiosk',
    'settings.groups.kiosk.nameDisplay': 'How names show on the kiosk',
    'settings.groups.signIn': 'Sign in',
    'settings.groups.signIn.welcomeMessage': 'Message after sign-in',
    'settings.groups.signOut': 'Sign out',
    'settings.groups.signOut.message': 'Message after sign-out',
};
//# sourceMappingURL=s1.js.map